
import { userAgent, token, tokenParse, tokenClear, tokenCheck, encodeBase64 } from '@/assets/ts/util';
import { WechatCreditPay as WechatCreditPayService, UserCenter, getToken, Authorize } from '@/service';
import { Vue, Component, Ref } from 'vue-property-decorator';
import loading from '@/components/loading.vue';
import plateKeyboard from '@/components/plate-keyboard.vue';

@Component({
    name: 'WechatCreditPay',
    components: {
        loading,
        plateKeyboard,
    },
})
export default class WechatCreditPay extends Vue {

    @Ref('keyboard')
    public readonly keyboard!: plateKeyboard;

    public $message!: any;
    public moment!: any;

    public isMiniprogram: boolean = false;
    public canILaunch: boolean = false;
    public appid: string = '';
    public plate: string = '';
    public openid: string = '';
    public loading: boolean = false;

    public plateColor: string = 'BLUE';
    public isSearched: boolean = false;
    public result: Record<string, any> = {};
    public get resultPlateColor() {
        switch (this.result?.package?.extraData?.plate_color) {
            case 'BLUE':
                return '蓝色';
            case 'YELLOW':
                return '黄色';
            case 'GREEN':
                return '绿色';
            case 'BLACK':
                return '黑色';
            case 'WHITE':
                return '白色';
            case 'LIMEGREEN':
                return '黄绿色';
            default:
                return '未知' + this.result?.package?.extraData?.plate_color;
        }
    }
    public get resultUserState() {
        switch (this.result.user_state) {
            case 'NORMAL':
                return '正常服务';
            case 'PAUSE':
                return '暂停服务';
            case 'OUT_SERVICE':
                return '未开通';
            default:
                return '未知' + this.result.user_state;
        }
    }
    public get resultOpenTime() {
        if (this.result.open_time) {
            return this.moment.unix(this.result.open_time).format('YYYY-MM-DD HH:mm:ss');
        }
        return '-';
    }

    public launchUsername: string = 'gh_518c42c65952';
    public launchPath: string = '';

    public initEnv() {
        const UA = navigator.userAgent;

        const checkVersion = (version: string, baseVersion: string) => {
            try {
                const [first, second = 0, third = 0] = version.split('.');
                const [f, s, t] = baseVersion.split('.');
                if (Number(first) > Number(f)) {
                    return true;
                } else if (Number(first) === Number(f)) {
                    if (Number(second) > Number(s)) {
                        return true;
                    } else if (Number(second) === Number(s)) {
                        return Number(third) >= Number(t);
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } catch (err) {
                console.warn('checkVersion Error:', err);
                return false;
            }
        };

        const checkOS = () => {
            const android = UA.match(/Android \d+(\.\d+\.\d+)?/)?.[0].replace('Android ', '');
            const ios = UA.match(/OS \d+_\d+ like Mac OS X/)?.[0]
                .replace('OS ', '')
                .replace(' like Mac OS X', '')
                .replace('_', '.');
            if (android) {
                return checkVersion(android, '5.0.0');
            }
            if (ios) {
                return checkVersion(ios + '.0', '10.3.0');
            }
            return false;
        };

        switch (userAgent()) {
            case 'Wechat':
                const v = UA.match(/MicroMessenger\/\d+\.\d+\.\d+/)?.[0].replace('MicroMessenger/', '');
                if (!v) {
                    this.canILaunch = false;
                    break;
                }
                if (this.isMiniprogram) {
                    this.canILaunch = false;
                    break;
                }
                this.canILaunch = checkVersion(v, '7.0.12') && checkOS();
                break;
            default:
                this.canILaunch = false;
                break;
        }
    }

    public handlePlateInput(plate: string) {
        if (plate.length > 7) {
            this.plateColor = 'GREEN';
        }
    }

    public handlePlateColorChange(color: 'BLUE' | 'YELLOW' | 'GREEN') {
        this.plateColor = color;
    }

    public async init() {
        if (this.isMiniprogram) {
            this.afterInit();
            return;
        }

        const callback = location.href
            + (location.search ? '&' : '?')
            + 'repeat=1';

        if (tokenCheck()) {
            const userInfo = tokenParse() || {};
            this.openid = userInfo.openid;
            this.appid = 'wxb81e3f60edef163c';
            if (userInfo.phone
                || this.$route.query.repeat === '1'
            ) {
                try {
                    const { status, data } = await UserCenter.majorPlate();
                    if (status === 1 && data?.length > 0) {
                        this.plate = data[0].platenumber;
                    } else {
                        this.plate = '';
                    }
                } catch (error) {
                    this.plate = '';
                    console.warn(error);
                } finally {
                    this.afterInit();
                }
            } else {
                tokenClear();
                Authorize(encodeBase64(callback));
            }
        } else if (this.$route.query.token_sign
            && this.$route.query.unionid
        ) { // 用户中心2.0换token
            if (userAgent() === 'Wechat' && !this.$route.query.openid) {
                Authorize(encodeBase64(callback));
            } else {
                const { unionid, token_sign } = this.$route.query;

                try {
                    const tokenData: any = await this.getToken(unionid, token_sign);
                    token(tokenData.token);
                    this.init();
                } catch (error) {
                    console.warn(error);
                }
            }
        } else {
            Authorize(encodeBase64(callback));
        }
    }

    public async getToken(unionid: any, tokenSign: any): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await getToken(unionid, tokenSign);
                resolve(data);
            } catch (err) {
                console.warn(err);
                reject(err);
            }
        });
    }

    public afterInit() {
        this.config();
        wx.ready(() => {
            if (this.isMiniprogram) {
                const {
                    plate = '',
                    openid = '',
                    appid = '',
                } = this.$route.query;

                this.plate = plate as string ?? '';
                this.openid = openid as string ?? '';
                this.appid = appid as string ?? '';
            }

            this.isSearched = false;
            this.initEnv();
        });
    }

    public searchWrap() {
        if (this.keyboard) {
            this.search(this.keyboard.currentPlate);
        } else {
            console.warn('ref.keyboard is not defined');
        }
    }

    public async search(plate: string) {
        if (plate.length < 6) {
            this.$message('请输入有效车牌');
            return;
        }

        if (!this.appid) {
            this.$message('appid丢失');
            return;
        }

        if (!this.isMiniprogram && !this.openid) {
            this.openid = tokenParse()?.openid ?? '';
        }

        if (!this.openid) {

            this.$message('openid丢失');
            return;
        }

        this.loading = true;
        try {
            const { rt_code, data, msg } = await WechatCreditPayService.check({
                openid: this.openid,
                plate,
                plate_color: this.plateColor,
                appid: this.appid,
            });

            const urlParams = [];
            const extraData = data.package.extraData;
            let path = data.package.path.replace(/^\//, '');

            for (const key in extraData) {
                if (extraData.hasOwnProperty(key)) {
                    urlParams.push(`${key}=${extraData[key]}`);
                }
            }

            if (urlParams.length) {
                path += '?' + urlParams.join('&');
            }

            this.launchPath = path;
            this.isSearched = true;
            this.result = data;
            this.$forceUpdate();

        } catch (err) {
            console.warn(err);
        } finally {
            this.loading = false;
        }
    }

    public back() {
        this.isSearched = false;
        this.result = {};
        this.$forceUpdate();
    }

    public post() {
        const { appId, path, extraData } = this.result.package;
        wx.miniProgram.postMessage({
            data: {
                appId,
                path,
                extraData,
            },
        });
        wx.miniProgram.switchTab({
            url: '/pages/index/index?from=h5&type=mini',
        });
    }

    private ready(e: any) {
        console.log('ready', e);
    }

    private launch(e: any) {
        console.log('launch', e, '\r\nparams:', {
            result: this.result,
            username: this.launchUsername,
            path: this.launchPath,
        });
    }

    private error(e: any) {
        console.log('error', e);
        this.canILaunch = false;
    }

    private async config() {
        switch (userAgent()) {
            case 'Wechat':
                try {
                    const { data } = await UserCenter.JSSDKConfig();
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
                        appId: window.SERVER_CONFIG.APPID, // 必填，公众号的唯一标识
                        timestamp: data.timestamp, // 必填，生成签名的时间戳
                        nonceStr: data.noncestr, // 必填，生成签名的随机串
                        signature: data.sign, // 必填，签名
                        jsApiList: ['getLocation'], /** 必填，需要使用的JS接口列表，@important 至少填一项否则不授权，包括开放标签 */
                        openTagList: ['wx-open-launch-weapp'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
                    });
                } catch (error) {
                    console.warn(error);
                }
                break;
        }
    }

    private created() {
        wx.miniProgram.getEnv((res: any) => {
            console.log('wx.miniProgram env', res);
            this.isMiniprogram = !!res.miniprogram;
            this.init();
        });
    }

    private mounted() {
        document.addEventListener('WeixinOpenTagsError', (e: any) => {
            console.error('开放标签加载失败', e.detail.errMsg); // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开发标签，JS-SDK其他功能不受影响
        });
    }
}
